// extracted by css-extract-rspack-plugin
export default {"count":"IBSTWS","valuePart":"DPheuc","cross":"ZF8Voj","value":"GoAi5x"};